export const OrderGroupCargoType = {
	incoming: 1,
	outgoing: 2,
};
